module.exports = __webpack_public_path__ + "static/img/13.1a04314.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/eng/13.png
// module id = tbnO
// module chunks = 0